import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Pasaré hambre?',
  a: 'No, el protocolo se basa en grasas y proteínas que te mantienen saciada mientras eliminamos el azúcar.'
}, {
  q: '¿Es difícil de seguir?',
  a: 'Está diseñado para personas ocupadas; las técnicas de rescate toman menos de un minuto.'
}, {
  q: '¿Tengo que comprar suplementos caros?',
  a: 'No, los minerales recomendados son económicos y fáciles de encontrar en cualquier farmacia.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-[#0f0f18]" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-center text-white mb-12" data-id="element-25">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-[#161622] border-[#00d4ff]/30' : 'bg-[#0a0a0f] border-white/5 hover:border-white/10'}`} data-id="element-27">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-28">
                  <span className={`font-inter font-semibold text-lg ${isOpen ? 'text-[#00d4ff]' : 'text-white'}`} data-id="element-29">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#00d4ff]' : 'text-[#a0a0b0]'}`} data-id="element-30" />
                </button>

                <AnimatePresence data-id="element-31">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-32">
                      <div className="px-6 pb-5 text-[#a0a0b0] font-inter leading-relaxed" data-id="element-33">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}